import { createFileRoute } from '@tanstack/react-router';
import { BillingSettings } from '../components/settings/BillingSettings';

export const Route = createFileRoute('/settings/billing')({
  validateSearch: (search: Record<string, unknown>): { checkout?: string } => ({
    ...(typeof search.checkout === 'string' ? { checkout: search.checkout } : {}),
  }),
  component: SettingsBillingPage,
});

function SettingsBillingPage() {
  const { checkout } = Route.useSearch();
  return <BillingSettings checkout={checkout} />;
}
